import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5744b8e3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-outer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-align-center font-weight-600 padding-20 padding-top-0"
}, [/*#__PURE__*/_createElementVNode("p", null, "👏🏻欢迎体验JoinMC💪"), /*#__PURE__*/_createElementVNode("p", null, "请按照流程注册您的账号")], -1));
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "flex-box van-hairline--bottom"
};
const _hoisted_5 = {
  style: {
    "margin": "var(--van-padding-md) 0"
  }
};
const _hoisted_6 = {
  style: {
    "margin": "var(--van-padding-md)"
  }
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  style: {
    "margin": "var(--van-padding-md) 0"
  }
};
const _hoisted_9 = {
  style: {
    "margin": "var(--van-padding-md)"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_countrySelectComp = _resolveComponent("countrySelectComp");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_captchasInfoDIalog = _resolveComponent("captchasInfoDIalog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, $data.isPhoneLogin ? (_openBlock(), _createElementBlock("section", _hoisted_3, [_createVNode(_component_van_form, {
    onSubmit: $options.onPhoneSubmit,
    onFailed: $options.onPhoneFailed,
    style: {
      "margin": "var(--van-padding-md)"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_field, {
      style: {
        "flex": "0 0 20%"
      },
      readonly: "",
      clickable: "",
      placeholder: "选择国家/地区",
      modelValue: $data.phoneRegistFormData.mobile_prefix,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.phoneRegistFormData.mobile_prefix = $event),
      onClick: _cache[1] || (_cache[1] = $event => $data.showPrefixPopup = true)
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $data.phoneRegistFormData.mobile_number,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.phoneRegistFormData.mobile_number = $event),
      placeholder: "请输入手机号",
      type: "tel",
      rules: [{
        validator: $options.validatorPhone
      }]
    }, null, 8, ["modelValue", "rules"])]), _createVNode(_component_van_field, {
      modelValue: $data.phoneRegistFormData.verification_code,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.phoneRegistFormData.verification_code = $event),
      placeholder: "请输入验证码",
      clearable: "",
      rules: [{
        required: true,
        message: '请输入验证码'
      }]
    }, {
      button: _withCtx(() => [_createVNode(_component_van_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => $options.onSendCode(true)),
        disabled: $data.countdown > 0
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.countdown > 0 ? `${$data.countdown}秒后重新获取` : "获取验证码"), 1)]),
        _: 1
      }, 8, ["disabled"])]),
      _: 1
    }, 8, ["modelValue"]), _createVNode(_component_van_field, {
      autocomplete: "off",
      modelValue: $data.phoneRegistFormData.account,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.phoneRegistFormData.account = $event),
      placeholder: "请输入登录账号",
      clearable: "",
      rules: [{
        required: true,
        message: '请输入登录账号'
      }]
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      autocomplete: "off",
      type: "password",
      modelValue: $data.phoneRegistFormData.password,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.phoneRegistFormData.password = $event),
      placeholder: "请输入登录密码",
      clearable: "",
      rules: [{
        required: true,
        message: '请输入登录密码'
      }]
    }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
      round: "",
      block: "",
      loading: $data.isLoading,
      type: "primary",
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_createTextVNode("注 册")]),
      _: 1
    }, 8, ["loading"])])]),
    _: 1
  }, 8, ["onSubmit", "onFailed"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_button, {
    style: {
      "margin": "var(--van-padding-md) 0"
    },
    onClick: _cache[7] || (_cache[7] = $event => $data.isPhoneLogin = false),
    block: "",
    round: ""
  }, {
    default: _withCtx(() => [_createTextVNode("使用邮箱注册")]),
    _: 1
  }), _createVNode(_component_van_button, {
    style: {
      "margin": "var(--van-padding-md) 0"
    },
    onClick: _cache[8] || (_cache[8] = $event => $options.returnLogin()),
    round: "",
    block: "",
    type: "success"
  }, {
    default: _withCtx(() => [_createTextVNode("已有账号？去登录")]),
    _: 1
  })])])) : (_openBlock(), _createElementBlock("section", _hoisted_7, [_createVNode(_component_van_form, {
    onSubmit: $options.onEmailSubmit,
    onFailed: $options.onEmailFailed,
    style: {
      "margin": "var(--van-padding-md)"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_van_field, {
      modelValue: $data.emailRegistFormData.email,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.emailRegistFormData.email = $event),
      placeholder: "请输入邮箱地址",
      type: "email",
      clearable: "",
      rules: [{
        required: true,
        message: '请输入邮箱地址'
      }]
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      modelValue: $data.emailRegistFormData.verification_code,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.emailRegistFormData.verification_code = $event),
      placeholder: "请输入邮件里的验证码",
      clearable: "",
      rules: [{
        required: true,
        message: '请输入验证码'
      }]
    }, {
      button: _withCtx(() => [_createVNode(_component_van_button, {
        type: "primary",
        onClick: _cache[10] || (_cache[10] = $event => $options.onSendCode(false)),
        disabled: $data.countdown > 0
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.countdown > 0 ? `${$data.countdown}秒后重新获取` : "获取验证码"), 1)]),
        _: 1
      }, 8, ["disabled"])]),
      _: 1
    }, 8, ["modelValue"]), _createVNode(_component_van_field, {
      autocomplete: "off",
      modelValue: $data.emailRegistFormData.account,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.emailRegistFormData.account = $event),
      placeholder: "请输入登录账号",
      clearable: "",
      rules: [{
        required: true,
        message: '请输入登录账号'
      }]
    }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
      autocomplete: "off",
      type: "password",
      modelValue: $data.emailRegistFormData.password,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.emailRegistFormData.password = $event),
      placeholder: "请输入登录密码",
      clearable: "",
      rules: [{
        required: true,
        message: '请输入登录密码'
      }]
    }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_button, {
      round: "",
      block: "",
      loading: $data.isLoading,
      type: "primary",
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_createTextVNode("注 册")]),
      _: 1
    }, 8, ["loading"])])]),
    _: 1
  }, 8, ["onSubmit", "onFailed"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
    style: {
      "margin": "var(--van-padding-md) 0"
    },
    onClick: _cache[14] || (_cache[14] = $event => $data.isPhoneLogin = false),
    block: "",
    round: ""
  }, {
    default: _withCtx(() => [_createTextVNode("使用手机号注册")]),
    _: 1
  }), _createVNode(_component_van_button, {
    style: {
      "margin": "var(--van-padding-md) 0"
    },
    onClick: _cache[15] || (_cache[15] = $event => $options.returnLogin()),
    round: "",
    block: "",
    type: "success"
  }, {
    default: _withCtx(() => [_createTextVNode("已有账号？去登录")]),
    _: 1
  })])]))]), _createVNode(_component_van_popup, {
    show: $data.showPrefixPopup,
    "onUpdate:show": _cache[17] || (_cache[17] = $event => $data.showPrefixPopup = $event),
    position: "right",
    style: {
      width: '100%',
      height: '100%',
      overflow: 'hidden'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_countrySelectComp, {
      onClose: _cache[16] || (_cache[16] = $event => $data.showPrefixPopup = false),
      onConfirm: $options.onConfirmPrefix
    }, null, 8, ["onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_captchasInfoDIalog, {
    ref: "captchasInfoDIalog",
    onReload: $options.getCaptches,
    onOnConfirm: $options.onCaptchaConfirm
  }, null, 8, ["onReload", "onOnConfirm"])], 64);
}